import React from 'react';

// The nine names the backend serves in code_table. Order here is arbitrary —
// the served table is authoritative for digit-to-symbol mapping.
export const SYMBOL_NAMES = [
  'circle', 'cross', 'caret', 'tilde', 'triangle', 'square', 'star', 'arc', 'zigzag',
];

const STROKE = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 10,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

const PATHS = {
  circle: <circle cx="50" cy="50" r="34" {...STROKE} />,
  cross: <path d="M22 22 L78 78 M78 22 L22 78" {...STROKE} />,
  caret: <path d="M20 68 L50 30 L80 68" {...STROKE} />,
  tilde: <path d="M16 52 Q33 26 50 52 Q67 78 84 52" {...STROKE} />,
  triangle: <path d="M50 20 L82 76 L18 76 Z" {...STROKE} />,
  square: <rect x="22" y="22" width="56" height="56" {...STROKE} />,
  star: <path d="M50 16 L61 42 L88 42 L66 59 L74 85 L50 69 L26 85 L34 59 L12 42 L39 42 Z" {...STROKE} />,
  arc: <path d="M16 33 A34 34 0 0 0 84 33" {...STROKE} />,
  zigzag: <path d="M14 66 L34 34 L50 66 L66 34 L86 66" {...STROKE} />,
};

// An unknown name renders an empty box rather than throwing — the symbol set
// is server-supplied and a future addition should degrade, not crash the run.
export function Glyph({ name, size = 32 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      aria-hidden="true"
      focusable="false"
      style={{ color: 'var(--text-primary)', display: 'block' }}
    >
      {PATHS[name] || null}
    </svg>
  );
}
